import React from 'react';
import TestGrid from './TestGrid';
import useTestFetching from '../hooks/useTestFetching';
import useTestActions from '../hooks/useTestActions';

const SampleTestList = () => {
  const { 
    tests, 
    loading, 
    error, 
    isLastPage,
    isFirstPage,
    fetchNextPage,
    fetchPrevPage
  } = useTestFetching({
    topic: 'MATH',
    endpoint: 'samples' // Fetch from the new 'samples' endpoint
  });

  const { handleStartTest, handlePayment } = useTestActions();

  return (
    <div className="container">
      {/* Header Section */}
      <div className="section-header">
        <h1 className="section-title">Sample Assessments</h1>
        <div className="section-subtitle">
          Try out our sample tests to get a feel for the platform
        </div>
      </div>

      <TestGrid
        tests={tests}
        onStartTest={handleStartTest}
        onPayment={handlePayment}
        variant="compact"
        loading={loading}
        error={error}
      />
      
      {/* Pagination Controls */}
      {!loading && !error && tests.length > 0 && (
        <div style={{
          width: '100%',
          paddingTop: 'var(--spacing-2xl)',
          marginTop: 'var(--spacing-2xl)',
          borderTop: '1px solid var(--border-color)'
        }}>
          <div style={{ 
            display: 'flex',
            justifyContent: 'center',
            gap: 'var(--spacing-md)'
          }}>
            <button
              onClick={fetchPrevPage}
              disabled={isFirstPage}
              className="button button-secondary"
            >
              Previous
            </button>
            <button
              onClick={fetchNextPage}
              disabled={isLastPage}
              className="button button-primary"
            >
              Next
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SampleTestList; 